import { isNull } from '~/misc/Utils'
import IMask from 'imask'
import axios from 'axios'

export default class Contact {
    constructor() {
        this.getDom()
        this.bindEvents()
        this.init()
    }

    getDom() {
        this.form = document.getElementById('zendesk-contact-form')
        this.errorElement = document.querySelector('.contact-form__errors')
        this.errorList = document.querySelector('.contact-form__errors ul')
        this.dateField = document.querySelector('.js-date')
    }

    bindEvents() {
        if (!isNull(this.form)) {
            this.form.addEventListener('submit', this.handleSubmit.bind(this))
        }
    }

    init() {
        if (!isNull(this.dateField)) {
            IMask(this.dateField, {
                mask: '00/00/0000',
                lazy: true,
                min: new Date(1900, 0, 1),
                max: new Date(),
                separator: '/',
            })
        }
    }

    handleSubmit(event) {
        event.preventDefault()
        this.errorElement.classList.remove('is-visible')
        this.preformRequest(event)
    }

    preformRequest(event) {
        const formData = new FormData(event.target)
        const button = event.target.querySelector('.form-submit')

        // Combine first and last name into one field
        const firstName = formData.get('custom_fields[first_name]')
        const lastName = formData.get('custom_fields[last_name]')
        formData.set('custom_fields[customer_name]', `${firstName} ${lastName}`)

        button.classList.add('is-loading')

        axios
            .post('https://zendesk.xrockeruk.com/api/v1/contact', formData)
            .then((response) => {
                setTimeout(() => {
                    window.location.replace('/pages/thank-you')
                }, 500)
            })
            .catch((error) => {
                if (error.response.status === 422) {
                    const items = Object.values(error.response.data.errors).flat()
                    this.errors(items)
                }
            })
            .finally(() => {
                button.classList.remove('is-loading')
            })
    }
    errors(errors) {
        this.errorList.innerHTML = ''
        this.errorElement.classList.add('is-visible')

        errors.forEach((error) => {
            const li = document.createElement('li')
            li.innerHTML = error
            this.errorList.appendChild(li)
        })

        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })
    }
}
